

class UpdateMarkerScorecard {
    constructor($el) {
        this.courseId = null;
        this.loopId = null;
        this.qualifying = null;

		this.$element = $el;
        this.$marker = this.$element.find('.js-marker');
		this.$markerInput = this.$element.find('.js-marker-input');
        this.$button = this.$element.find('.button');
        this.$markerUpdate = this.$element.find('.js-marker-update');
        this.$markerUpdated = this.$element.find('.js-marker-updated');
        this.$markerUpdatedError = this.$element.find('.js-marker-updated-error');
        this.url = this.$markerInput.data('updatemarker-url');
        this.defaultValue = parseInt(this.$element.find('option.js-default-value').val());

        // init events
        this.events();
    }

	/**
	 * Method to update the marker of a scorecard
	 * @param {any} ev
	 */
	updateMarker(ev) {
		// get scorecard id
        var scorecardId = this.$element.data('scorecardid') != null ? this.$element.data('scorecardid') : this.$element.attr('id');
		// get new marker id
        var markerId = $(this.$markerInput).find(':selected').val();
        this.$button.addClass('is-loading');

		// call updateMarker API to update marker
		//TODO: (FE) set correct done/fail callbacks.
		$.ajax({
			url: this.url,
			dataType: 'json',
			type: 'POST',
			data: { 'scorecardId': scorecardId, 'markerId': markerId }
        }).done((data) => {
            this.defaultValue = data.markerId;
		    this.$button.removeClass('is-loading');
            this.hide(this.$markerUpdate);
            this.show(this.$markerUpdated);
            this.hide(this.$markerUpdatedError);
		}).fail(() => {
		    this.$button.removeClass('is-loading');
            this.hide(this.$markerUpdate);
            this.hide(this.$markerUpdated);
            this.show(this.$markerUpdatedError);
		});
	}

    /**
     * Initializes the event handlers
     */
	events() {
        this.$button.on('click.markerUpdateSubmit', (e) => { this.updateMarker(e); });
        this.$markerInput.on('select2:select', (e) => {
            if (e.params != null && e.params.data.id !== this.defaultValue) {
                this.show(this.$markerUpdate);
                this.hide(this.$markerUpdated);
                this.hide(this.$markerUpdatedError);
            } else {
                this.hide(this.$markerUpdate);
                this.hide(this.$markerUpdated);
                this.hide(this.$markerUpdatedError);
            }
        });
    }

    hide($el) {
        $el.addClass('u-hide');
    }

    show($el) {
        $el.removeClass('u-hide');
    }

}

export default UpdateMarkerScorecard;
